import { BrandSettingsInterface } from '@systemeio/types'
import {
  defaultBrandSettings,
  getBrandFromLocalStorage,
} from '@systemeio/util'
import { BRAND_SERVER_STORE_KEY } from './brand-server-constants'

interface BrandServerStore {
  getStore: () => BrandSettingsInterface | undefined
}

export const getServerSideBranding = (): BrandSettingsInterface | undefined => {
  const store = (globalThis as any)[BRAND_SERVER_STORE_KEY] as BrandServerStore | undefined
  return store?.getStore()
}

export const getBrand = (): BrandSettingsInterface => {
  return getServerSideBranding() ?? getBrandFromLocalStorage() ?? defaultBrandSettings
}
